export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://quicktab.eu';
export const PLATFORM_URL = import.meta.env.VITE_PLATFORM_URL || 'https://quicktab.eu';
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'production';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh-token',
  },
  EXCEL_AUTH: {
    LOGIN: '/auth/login',
    REFRESH_TOKEN: '/auth/refresh-token',
  },
  PLATFORM: {
    VIEW: '/user/platform-view',
    EXECUTE: '/user/platform-execute',
    CREDIT_BALANCE: '/user/credit-balance',
    CUSTOMER_SUPPORT: '/user/customer-support',
    PRODUCT_LIST: '/user/product-list',
  },
};

export const isDevelopment = ENVIRONMENT === 'staging';
